import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

// Same monitoring-surface policy as the Team Live wall: poll so tiles
// appear/disappear quickly as devices start and stop Trackcast; poll only
// slightly slower while the page is empty.
const POLL_INTERVAL_MS = 3_000;
const EMPTY_POLL_INTERVAL_MS = 5_000;

export function useMyLiveStreams() {
  return useQuery({
    queryKey: ["my-live-streams"],
    queryFn: () => apiClient.getMyLiveStreams(),
    refetchInterval: (query) =>
      query.state.data?.active.length || query.state.data?.recent.length
        ? POLL_INTERVAL_MS
        : EMPTY_POLL_INTERVAL_MS,
    // Monitoring surface, often left unattended; react-query otherwise
    // pauses the interval while the tab is unfocused and tiles go stale.
    // Live WHEP connections exempt the page from intensive throttling.
    refetchIntervalInBackground: true,
  });
}
